import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/js/src/collapse"
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store, persister} from "./redux/store";
import {PersistGate} from "redux-persist/integration/react";
import axios from "axios";
import {signoutSuccess, setAccessToken} from "./redux/user/user.actions";
import "./fonts/Montserrat-Medium.ttf";
import "./fonts/Montserrat-Regular.ttf";
import "./fonts/Montserrat-SemiBold.ttf";
import {BaseURL} from "./utils/baseUrl";

// interceptor for sending Auth Token with all axios APIs
axios.interceptors.request.use(
    (config) => {
        // get redux store
        const state = store.getState();
        // get authentication Data from "user's state" present in the store
        const authenticationData = state.user.authenticationData;
        // if access_token is present in the state then use that or else accessToken = null
        const accessToken = authenticationData ? authenticationData.access_token : null;
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            const originalRequest = error.config;
            if ((error.response.status === 401 || error.response.status === 403) &&
                (originalRequest.url.includes("token-refresh") || originalRequest.url.includes("authenticate"))) {
                store.dispatch(signoutSuccess());
                return Promise.reject(error);
            }
            if (error.response.status === 401 || error.response.status === 403) {
                const userState = store.getState().user;
                const refreshToken = userState.authenticationData.refresh_token;
                if (refreshToken) {
                    return axios.post(BaseURL + "token-refresh", {refresh_token: refreshToken})
                        .then((res) => {
                            if (res.status === 201) {
                                store.dispatch(setAccessToken(res.data.access_token));
                                axios.defaults.headers.common["Authorization"] =
                                    userState.authenticationData.access_token;
                                return axios(originalRequest);
                            }
                        })
                        .catch((err) => {
                            if (err.response.data.application_error_code) {
                                //TODO: Introduce toaster
                                store.dispatch(signoutSuccess());
                                return Promise.reject(error);
                            }
                        });
                } else {
                    store.dispatch(signoutSuccess());
                    return Promise.reject(error);
                }
            }
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error);
        } else {
            return {
                data: {
                    detail:
                        "Something Went Wrong!!! Please contact support at https://support.callation.com/",
                },
            };
        }
    }
);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <PersistGate persistor={persister}>
                <App/>
            </PersistGate>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
